import type {EntityType} from 'nutshell-graphql-types';

import type {EntityFormType} from '../types';

export function translateEntityFormTypeToFieldEntityType(entityType: EntityFormType): EntityType {
    switch (entityType) {
        case 'contacts':
            // @ts-expect-error
            return 'CONTACT';
        case 'accounts':
            // @ts-expect-error
            return 'ACCOUNT';
        case 'leads':
        default:
            // @ts-expect-error
            return 'LEAD';
    }
}
